

import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class SyncXDNsDialog extends Vue {
  public visible: boolean = true;

  public message: string = 'Are you sure you want to sync xdns?';

  public sync(): void {
    this.$emit('sync');
    this.$successDialog.show('XDN Sync Started');
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
